import React, { useEffect, useState } from "react";
import { formatCurrency, getLink, permisions, toast } from "../../../utils/helpers";
import useFilters from "../../../hooks/useFilters";
import { Link } from "react-router-dom";
import PageHeader from "../../general/PageHeader";
import FiltersContainer from "../../general/FiltersContainer";
import Loader from "../../general/Loader";
import Pagination from "../../general/Pagination";
import { request } from "../../../utils/request";
import { apiRequest } from "../../../hooks/apiRequest";
import Modal from "../../general/Modal";
import { auth } from "../../../utils/auth";

const Inventario = () => {
    const [insumos, setIsumos] = useState({});
    const [loading, setLoading] = useState(false);

    const [selectedInsumo, setSelectedInsumo] = useState();
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [deleting, setDeleting] = useState(false);

    const { handleFilterChange, filtersQuery } = useFilters({buscar: null});

    const getInsumos = async (url) => {
        url = url ? url + "&limit=15" : `salud/insumos?limit=15`;

        setLoading(true);

        const response = await request(url);

        setIsumos(response);

        setLoading(false);
    };

    const openDeleteModal = (insumo) => {
        setSelectedInsumo(insumo);

        setShowDeleteModal(true);
    };

    const closeDeleteModal = () => {
        setSelectedInsumo();

        setShowDeleteModal(false);
    };

    const eliminarInsumo = async () => {
        setDeleting(true);

        const response = await apiRequest({}, `salud/insumos/${selectedInsumo.id}`, 'delete');

        if (response.success) {
            toast("Insumo Eliminado", "success");
            
            closeDeleteModal();

            getInsumos(`salud/insumos${filtersQuery}`);
        } else {
            toast(response.data.message, "error");
        }

        setDeleting(false);
    };

    useEffect(() => {
        getInsumos(`salud/insumos${filtersQuery}`);
    }, [filtersQuery]);

    return <>
        <PageHeader title="Insumos Médicos">
            {auth.can(permisions.reporteSaludInsumos) && <Link
                className='au-btn au-btn-icon au-btn-filter au-btn--small mr-2'
                to={getLink(
                    `/imprimir/salud/inventario${filtersQuery}`
                    )}
                target='_blank'>
                <i className='zmdi zmdi-print' />
                Imprimir
            </Link>}
            <Link
                className="au-btn au-btn-icon au-btn--green au-btn--small m-r-15 ml-auto mt-2 mt-lg-0"
                to={getLink('/salud/inventario/crear')}
            >
                <i className="zmdi zmdi-plus" />
                Nuevo Insumo
            </Link>
        </PageHeader>

        <FiltersContainer>
            <div className='col'>
                <label htmlFor='search'>Buscar</label>
                <input
                    name='buscar'
                    onChange={(e) => handleFilterChange("buscar", e?.target.value)}
                    type='search'
                    placeholder='Buscar...'
                    className='form-control'
                />
            </div>

            <div className='col-3'>
                <label htmlFor='estado'>Tipo</label>
                <select
                    name="tipo"
                    className="form-control"
                    placeholder="Seleccionar..."
                    onChange={e => handleFilterChange('tipo', e.target.value)}
                >
                    <option value="">Todos</option>
                    <option value="Médica">Medicamento</option>
                    <option value="Psicología">Artículo</option>
                </select>
            </div>
        </FiltersContainer>

        <div className='row'>
            <div className='col-md-12'>
                <div>
                    <div className='table-data'>
                        <table className='table table-data2'>
                            <thead>
                                <tr>
                                    <th>NOMBRE</th>
                                    <th>REF.</th>
                                    <th>Tipo</th>
                                    <th>DISPONIBLE</th>
                                    <th>COSTO</th>
                                    <th>IMPUESTO</th>
                                    <th>Costo Total</th>
                                    <th>Total</th>
                                    <th>Descripción</th>
                                    <th></th>
                                </tr>
                            </thead>

                            <tbody>
                                {loading
                                    ? (<tr className="tr-shadow"><td colSpan={10}><Loader /></td></tr>)
                                    : (insumos?.data?.length
                                        ? insumos.data.map((insumo) => (<tr className="tr-shadow" key={insumo.id}>
                                            <td>{insumo.nombre}</td>
                                            <td>{insumo.referencia}</td>
                                            <td>{insumo.tipo}</td>
                                            <td>{`${insumo.cantidad} ${insumo.unidad}`}</td>
                                            <td>{formatCurrency(insumo.costo)}</td>
                                            <td>{insumo.impuesto?.label}</td>
                                            <td>{formatCurrency(insumo.costo * (1 + (insumo.impuesto?.porcentaje ?? 0)))}</td>
                                            <td>
                                                {formatCurrency((insumo.costo * (1 + (insumo.impuesto?.porcentaje ?? 0))) * insumo.cantidad)}
                                            </td>
                                            <td>{insumo.descripcion}</td>
                                            
                                            <td>
                                                <Link
                                                    data-toggle="tooltip"
                                                    data-placement="top"
                                                    title="Editar"
                                                    data-original-title="Edit"
                                                    className="item mx-1"
                                                    to={getLink(
                                                        `/salud/inventario/${insumo.id}`
                                                    )}
                                                >
                                                    <i className="zmdi zmdi-edit" />
                                                </Link>

                                                <button
                                                    className='item mx-1 text-danger'
                                                    data-toggle='tooltip'
                                                    data-placement='top'
                                                    title='Eliminar'
                                                    data-original-title='Eliminar'
                                                    onClick={() => openDeleteModal(insumo) }>
                                                    <i className="zmdi zmdi-delete" />
                                                </button>
                                            </td>
                                        </tr>))
                                        : <tr className="tr-shadow"><td colSpan={10}>No hay ningún insumo creado.</td></tr>
                                    )
                                }
                            </tbody>
                        </table>

                        {insumos?.links && (<Pagination links={insumos.links} meta={insumos.meta} getData={getInsumos} />)}
                    </div>
                </div>
            </div>
        </div>

        <Modal
            title={`Eliminar Insumo: ${selectedInsumo?.nombre}`}
            show={showDeleteModal}
            blank={false}
            callback={eliminarInsumo}
            toggle={closeDeleteModal}>
                {
                    deleting 
                    ? <><Loader /></> 
                    : <p className="px-3 pb-3">¿Estás seguro que desea eliminar este insumo? (Esta acción no se puede deshacer).</p>
                }
        </Modal>
    </>;
};

export default Inventario;
